<div class="flex flex-col gap-4" *transloco="let t">
  <textarea
    class="h-[250px]"
    [(ngModel)]="comment"
    placeholder="{{ t('modal-activity-comment.add_comment_placeholder') }}"
    maxlength="255"
  ></textarea>

  <div class="flex justify-between gap-2" *transloco="let t">
    <button iButton variant="secondary" size="md" (click)="modalRef.close()">{{ t("common.cancel") }}</button>
    <div class="flex gap-2">
      <button iButton variant="destructive" size="md" (click)="deleteComment()">{{ t("common.delete") }}</button>
      <button iButton size="md" (click)="save()">{{ t("common.save") }}</button>
    </div>
  </div>
</div>
